import React from "react";
import { Coffee } from "lucide-react";

export const LoyaltyDots = ({ stamps = 0, total = 10, size = "md" }) => {
    const dim = size === "lg" ? "h-6 w-6" : size === "sm" ? "h-3 w-3" : "h-4 w-4";
    return (
        <div className="flex items-center gap-1.5" data-testid="loyalty-dots">
            {Array.from({ length: total }).map((_, i) => {
                const filled = i < stamps;
                return (
                    <span
                        key={i}
                        data-testid={`loyalty-dot-${i}`}
                        className={`inline-flex ${dim} rounded-full items-center justify-center transition-all ${
                            filled
                                ? "bg-[#FF4F18] text-white shadow-[0_0_0_2px_rgba(255,79,24,0.15)] stamp-pop"
                                : "bg-transparent border border-[#E8DCCB]"
                        }`}
                    >
                        {filled && size === "lg" && <Coffee className="h-3 w-3" strokeWidth={3} />}
                    </span>
                );
            })}
        </div>
    );
};

export default LoyaltyDots;
